import React from 'react';
import fullLogo from '../SE_Logo.svg';
import './VersionUpdateUi.css';

export default function VersionUpdateUi({ onReload }) {
  const handleReload = () => {
    if ('caches' in window) {
      caches.keys().then(names => {
        for (let name of names) caches.delete(name);
      }).then(() => window.location.reload());
    } else {
      window.location.reload(true); // Legacy fallback
    }
  };

  const reloadFunc = onReload || handleReload;

  return (
    <div className="version-update-container">
      <div className="version-update-logo-wrapper">
        <img className="version-update-logo" src={fullLogo} alt="School Engine Logo" />
      </div>
      <h1 className="version-update-title">An update is available for the app</h1>
      <button className="version-update-button" onClick={reloadFunc}>Update Now</button>
      <p className="version-update-help">
        If this message keeps  appearing, try pressing ctrl + F5 on your keyboard or email
        <a href="mailto:support@schoolengine.co.uk"> support@schoolengine.co.uk</a>
        {" "}or contact your system administrator.
      </p>
    </div>
  );
}
